import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { CustomChannelsDetail } from 'features/channels';
import { useGetPathToEntityDetail } from '../../hooks';

const PageCustomChannelsDetail = () => {
  const { channelId } = useRequiredParams<{ channelId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();

  return (
    <AppLayout>
      <CustomChannelsDetail channelId={channelId} getPathToEntityDetail={getPathToEntityDetail} />
    </AppLayout>
  );
};

export default PageCustomChannelsDetail;
